import i18n from '@/locale/index'

export default [
  // {
  //   path: '/blindBox',
  //   name: 'blindBox',
  //   component: () => import('../../views/blindBox/index.vue'),
  //   meta: {
  //     title: i18n.global.t('points.c5'),
  //     pageKey: 'Blindbox_ph2'
  //   }
  // },
  {
    path: '/blindBox',
    name: 'blindBox',
    component: () => import('../../views/blindBox/index_new.vue'),
    meta: {
      title: i18n.global.t('points.c5'),
      pageKey: 'Blindbox_ph2'
    }
  },
  {
    path: '/blindBox/rule',
    name: 'rule',
    component: () => import('../../views/blindBox/rule.vue'),
    meta: {
      title: i18n.global.t('box.c44')
    }
  },
  {
    path: '/blindBox/luckyCard',
    name: 'luckyCard',
    component: () => import('../../views/blindBox/luckyCard.vue'),
    meta: {
      title: i18n.global.t('box.c61')
    }
  },
  {
    path: '/blindBox/ruleData',
    name: 'ruleData',
    component: () => import('../../views/blindBox/ruleData.vue'),
    meta: {
      title: i18n.global.t('box.c44')
    }
  },
  {
    path: '/blindBox/record_new',
    name: 'record_new',
    component: () => import('../../views/blindBox/record_new.vue'),
    meta: {
      title: i18n.global.t('box.d51')
    }
  },
]
